import { cn } from '@Utils/cn';

export interface StageDataFieldProps {
  label: string;
  value: string;
  isLink?: boolean;
  onLinkClick?: () => void;
  className?: string;
  labelClassName?: string;
}

export function StageDataField({
  label,
  value,
  isLink = false,
  onLinkClick,
  className,
  labelClassName,
}: StageDataFieldProps) {
  const values = Array.isArray(value) ? value : [value];

  return (
    <div className={cn('flex flex-col items-start', className)}>
      <p
        className={cn(
          'text-sm leading-5 font-semibold text-zinc-500',
          labelClassName,
        )}
      >
        {label}
      </p>
      {isLink ? (
        <button
          type="button"
          onClick={onLinkClick}
          className="flex flex-col items-start text-base leading-6 font-normal text-black underline"
        >
          {values.map((val) => (
            <p>{val}</p>
          ))}
        </button>
      ) : (
        <div className="flex flex-col text-base leading-6 font-normal text-black">
          {values.map((val) => (
            <p>{val}</p>
          ))}
        </div>
      )}
    </div>
  );
}
